import Vue from 'vue'
import { findPipelineStepById } from 'utils/helpers/find-store'

Vue.filter('pmlPipelineStepById', function (id, field = 'name') {
    var item = findPipelineStepById(id)

    return (typeof item !== 'undefined') ? item[field] : ''
})



// WEBPACK FOOTER //
// ./src/utils/filters/store_getter/pipelineStepById.js